import { render, staticRenderFns } from "./TrainingHelpLinks.vue?vue&type=template&id=21a51805"
import script from "./TrainingHelpLinks.vue?vue&type=script&lang=js"
export * from "./TrainingHelpLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports